<template>
  <v-app>
    <v-main>
      <v-container class="inspire fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-14">
              <v-toolbar dark color="primary" class="formHeader">
                <v-toolbar-title>{{ $t('views.Login.changePassword') }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text class="formContent">
                <v-form>
                  <v-text-field
                    autofocus
                    prepend-icon="person"
                    name="email"
                    :label="$t('views.Login.email')"
                    v-model="email"
                    type="text"
                    id="email"
                    autocomplete="email"
                    :disabled="!canChangeEmail"
                  />
                  <v-text-field
                    prepend-icon="lock"
                    name="password"
                    :label="$t('views.Login.newPassword')"
                    v-model="password"
                    type="password"
                    id="password"
                    autocomplete="new-password"
                    @blur="validate"
                  />
                  <v-text-field
                    prepend-icon="lock"
                    name="confirmation"
                    :label="$t('views.Login.confirmation')"
                    v-model="confirmation"
                    type="password"
                    id="confirmation"
                    ref="confirmation"
                    :error="!valid"
                    autocomplete="off"
                    @input="validate"
                  />
                </v-form>
                <v-card-text class="errorMessage">
                  {{ errorMessage }}
                </v-card-text>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="primary"
                  @click="sendEmailLink"
                  :disabled="!valid"
                  id="sendEmailLink"
                  :loading="loading"
                  v-if="canRequestNewLink"
                >
                  {{ $t('views.Login.sendEmailLinkButton') }}
                </v-btn>
                <v-btn
                  color="primary"
                  @click="login"
                  :disabled="!valid"
                  @keydown.enter="login"
                  id="confirm"
                  :loading="loading"
                  v-else
                >
                  {{ $t('actions.confirm') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { types } from '../store/rootTypes';
import bugsnagClient from '../bugsnag';

export default {
  name: 'SetPassword',
  data() {
    return {
      email: '',
      password: '',
      confirmation: '',
      errorMessage: this.$t('views.Login.errors.missingPassword'),
      canChangeEmail: true,
      canRequestNewLink: false,
      loading: false,
      valid: false,
    };
  },
  methods: {
    validate() {
      if (this.password.trim() === '') {
        this.errorMessage = this.$t('views.Login.errors.missingPassword');
        this.valid = false;
      } else if (this.password !== this.confirmation) {
        this.errorMessage = this.$t('views.Login.errors.passwordMismatch');
        this.valid = false;
      } else {
        this.valid = true;
        this.errorMessage = '';
      }
    },
    async login() {
      this.loading = true;
      try {
        await this.$store.dispatch(types.authentication.actions.signinWithEmailLink, {
          url: window.location.href,
          email: this.email,
          password: this.password,
        });
        this.$router.push('/');
      } catch (error) {
        let errorCode = error.code;
        switch (error.code) {
          case 'auth/weak-password':
            this.canChangeEmail = false;
            break;
          case 'auth/invalid-action-code':
          case 'auth/expired-action-code':
          case 'auth/requires-recent-login':
            await this.$store.dispatch(types.authentication.actions.logout);
            this.canChangeEmail = false;
            this.canRequestNewLink = true;
            errorCode = 'expired';
            break;
          case 'auth/invalid-email':
            errorCode = 'emailMismatch';
            break;
          default:
            errorCode = 'unknown';
        }

        this.errorMessage = this.$t(`views.Login.errors.${errorCode}`);
        this.loading = false;
        bugsnagClient.notify(error);
      }
    },
    async sendEmailLink() {
      this.loading = true;
      try {
        await this.$store.dispatch(types.authentication.actions.sendEmailLink, {
          email: this.email,
        });
        this.errorMessage = '';
      } catch (error) {
        this.errorMessage = this.$t('views.Login.errors.unknown');
        bugsnagClient.notify(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.inspire {
  position: relative;
  background-image: url('~@/assets/images/background_login.jpg');
  background-size: cover;
  background-position: center center;
}
.formContent {
  width: 90%;
}
.formHeader {
  height: 15%;
}
.errorMessage {
  color: red;
}
</style>
